"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToAmount = exports.amountToString = exports.unitToString = exports.stringToUnit = void 0;
var Amount = require("./amount");
/**
 * @module Serialize
 */
/**
 * Converts a units serialized representation to it's deserialized representation
 * @param unitString
 */
function stringToUnit(unitString, unitLookup) {
    return unitLookup(unitString);
}
exports.stringToUnit = stringToUnit;
/**
 * Converts a unit to it's serialized representation
 * @param unit
 */
function unitToString(unit) {
    return unit.name;
}
exports.unitToString = unitToString;
/**
 * Convert an amount to it's serialized representation
 * @param amount
 */
function amountToString(amount) {
    if (!amount.value === null || amount.value === undefined) {
        return "";
    }
    var valueString = amount.value.toFixed(amount.decimalCount);
    var unitString = unitToString(amount.unit);
    return valueString + ":" + unitString;
}
exports.amountToString = amountToString;
/**
 * Convert a serialized amount to it's deserialized representation
 * @param amountString
 */
function stringToAmount(amountString, unitLookup) {
    var parts = amountString.split(":");
    var value = parseFloat(parts[0]);
    var unit = stringToUnit(parts[1], unitLookup);
    if (!unit) {
        return undefined;
    }
    var decimalCount = 0;
    var pointIndex = parts[0].indexOf(".");
    if (pointIndex >= 0) {
        decimalCount = parts[0].length - pointIndex - 1;
    }
    return Amount.create(value, unit, decimalCount);
}
exports.stringToAmount = stringToAmount;
//# sourceMappingURL=serialize.js.map